export default __webpack_public_path__ + "44ee26303d8ef4ba1cf4592cdd252b1f.png";